import { BACKEND_ROOT } from '../../config/host-config';
import { NotificationService } from '../../services';
import { SiteSettings } from '../../models/SiteSettings';
import { BaseAuthService } from './BaseAuthService';

export class SiteSettingsService extends BaseAuthService {
    notificationService: NotificationService;
    endpointRoot: string;

    constructor(notificationService: NotificationService) {
        super();

        this.notificationService = notificationService;
        
        this.endpointRoot = `${BACKEND_ROOT}/api/siteSettings`;
    }

    public get(): Promise<SiteSettings> {
        const endpoint = `${this.endpointRoot}`;
        const init = this.buildRequestInit('GET');

        return fetch(endpoint, init).then((response) => {
            if (response.ok) {
                return response.json();
            }

            const message = `Error retrieving Site Settings.`;
            this.notificationService.addError(message);
            throw response;
        });
    }

    public update(entity: SiteSettings): Promise<any> {
        const endpoint = `${this.endpointRoot}`;
        const init = this.buildRequestInit('PUT', entity);

        return fetch(endpoint, init).then((response) => {
            if (response.ok) {
                this.notificationService.addNotification(`Site Settings updated successfully.`);
                return response.json();
            }

            const message = `Error updating Site Settings.`;
            this.notificationService.addError(message);
            throw new Error(message);
        });
    }
}


// WEBPACK FOOTER //
// ./src/services/api/SiteSettingsService.tsx